<template>
    <!-- 

        {name: "C++并发编程", slug: "Cpp-Concurrency-In-Action", html_url: "/library/Cpp-Concurrency-In-Action",…}
        chapters_count: 18
        description: "本书是并发和多线程机制指导书籍(基于C++11标准)。从最基本的std::thread std::mutex和std::async的使用，到复杂的原子操作和内存模型。↵前4章，介绍了标准库提供的各种库工具，展示了使用方法。↵第5章，涵盖了底层内存模型和原子操作的实际情况，包括原子操作如何对执行顺序进行限制(这章标志着介绍部分的结束)。↵第6、7章，开始讨论高级主题，如何使用基本工具去构建复杂的数据结构——第6章是基于锁的数据结构，第7章是无锁数据结构。↵第8章，对设计多线程代码给了一些指导意见，覆盖了性能问题和并行算法。↵第9章，线程管理——线程池，工作队列和中断操作。↵第10章，测试和调试——Bug类型，定位Bug的技巧，以及如何进行测试等等。↵"
        html_url: "/library/Cpp-Concurrency-In-Action"
        issue_url: "https://github.com/xiaoweiChen/Cpp_Concurrency_In_Action/issues"
        name: "C++并发编程"
        repo_url: "https://github.com/xiaoweiChen/Cpp_Concurrency_In_Action"
        seo_keywords: []
        slug: "Cpp-Concurrency-In-Action"
        tags: [{name: "C++", picture_url: "https://dn-simplecloud.shiyanlou.com/tech-icon/C++.png"}]
     -->
    <div class="library_card_a" style="display: block">
        <div class="library_card_layout_div">
            <p class="library_card_title_p no_margin">{{ data.name }}</p>
            <p :class="data.description?'library_card_chapter_p no_margin':'no_display'">{{ data.description }}</p>
            <p class="library_card_chapter_p no_margin">{{ star_infos[data.id] }}</p>
        </div>
        <div class="library_card_img_layout_div">
            <img :title="skill_state==='hr'?star_info_list[4]:star_info_list_common[4]" data-index="0" :data-skill-id="data.id" :src="star[data.id][0]" class="skill_star_img" :data-state='data.state' @click="click_star($event)">
            <img :title="skill_state==='hr'?star_info_list[3]:star_info_list_common[3]" data-index="1" :data-skill-id="data.id" :src="star[data.id][1]" class="skill_star_img" :data-state='data.state' @click="click_star($event)">
            <img :title="skill_state==='hr'?star_info_list[2]:star_info_list_common[2]" data-index="2" :data-skill-id="data.id" :src="star[data.id][2]" class="skill_star_img" :data-state='data.state' @click="click_star($event)">
            <img :title="skill_state==='hr'?star_info_list[1]:star_info_list_common[1]" data-index="3" :data-skill-id="data.id" :src="star[data.id][3]" class="skill_star_img" :data-state='data.state' @click="click_star($event)">
            <img :title="skill_state==='hr'?star_info_list[0]:star_info_list_common[0]" data-index="4" :data-skill-id="data.id" :src="star[data.id][4]" class="skill_star_img" :data-state='data.state' @click="click_star($event)">
        </div>
    </div>
</template>
<script type="text/javascript">
import { mapState, mapActions  } from 'vuex'

export default {
    props: {
        data: {
            type: Object,
            require: true
        }
    },
    data: function () {
        return {
            skill_state: '',
        }
    },
    computed: {
        ...mapState({
            star: state => state.skill.star,
            star_infos: state => state.skill.star_infos,
            star_info_list: state => state.skill.star_info_list,
            star_info_list_common: state => state.skill.star_info_list_common,
        })
    },
    methods: {
        ...mapActions({
            load_star: 'skill/load_star',
            click_star: 'skill/click_star',
        })
    },
    mounted: function () {
        this.skill_state = localStorage.getItem('field')
    }

}
</script>
<style type="text/css" scoped>
.library_card_a {
    display: flex;
    border: 1px solid #eee;
    box-shadow: 0 1px 2px 0 #d2d2d2;
    padding: 11px 13px;
    margin-bottom: 32px;
}

.library_card_a:hover {
    box-shadow: 0 2px 8px 0 #d2d2d2;
}

.library_card_img_layout_div {
    display: block;
    padding: 10px 13px 10px 0;
}

.skill_star_img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.library_card_layout_div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.library_card_title_p {
    font-size: 16px;
    color: #565656;
    max-height: 45px;
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
}

.library_card_chapter_p {
    font-size: 14px;
    color: #666;
}

.no_margin {
    margin: 0;
}
.no_display {
    display: none;
}


</style>
